module.exports = __webpack_public_path__ + "static/media/plus.789949f8.svg";